// Every interactive/some static block types store their shape as a JSON
// string in `config` (backend validates nothing in it - see
// variables/exerciseBlockTypes.js for the documented per-type shapes).
export function safeParseConfig(configString, fallback) {
    if (!configString) return fallback;
    try {
        const parsed = JSON.parse(configString);
        return parsed && typeof parsed === "object" ? parsed : fallback;
    } catch (e) {
        return fallback;
    }
}
